import gift from "../assets/gift.svg";
import rss from "../assets/rss.svg";
import pullRequest from "../assets/pull-request.svg";
import installs from "../assets/install.svg";

const bottomCardDetails = [
  {
    icon: gift,
    title: "credits",
    description: "Konsole Night theme is developed and maintained by",
    link: "Enos Lyznne.",
    linkUrl: "https://www.github/lyznne"
  }, 
  {
    icon: rss,
    title: " feedback & review" ,
    description: "A  positive feedback is much appreciated 💫💫",
    link: "feedback ",
    linkUrl: ""
  },
  {
    icon: pullRequest,
    title: "Contributions",
    description: "The project is open source. All contributios are welcome ✨ ✨",
    link: "project",
    linkUrl: "https://www.github/lyznne"
  },
  {
    icon: installs,
    title: "installs",
    description: "more than 1000+ installs from the marketplace  is limit ",
    link: "marketplace",
    linkUrl: "https://www.github/lyznne"
  }

];

export default bottomCardDetails;
